import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-socio-asso',
  templateUrl: './socio-asso.component.html',
  styleUrls: ['./socio-asso.component.scss']
})
export class SocioAssoComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Sociological Association');
  }

}
